import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import PopupWindow from "../../primary/Displays/PopupWindow";
import Overlay from "../../../../Games/Shared/Overlay/Overlay";
import { useDimensions } from "../../../../Contexts/DimensionsContext";

// Connection popup timeout settings
const CONNECTION_POPUP_TIMEOUTS = {
  NATURAL_SPIN_DELAY: 350, // Buffer delay for regular spins (ms)
  MANUAL_STOP_BUFFER: 400, // Buffer delay for manual stops (ms)
};

const ConnectionPopup = () => {
  const { t } = useTranslation();
  const { connectionPopupActive } = useSelector((state) => state.userInterface);
  const overlayRef = useRef(null);
  const windowRef = useRef(null);
  const { dimensions } = useDimensions();

  const popupText = t("connection_message");

  useEffect(() => {
    if (connectionPopupActive && overlayRef.current) {
      overlayRef.current.fadeInBackground();
    }
  }, [connectionPopupActive]);

  if (!connectionPopupActive) {
    return null;
  }

  return (
    <>
      <Overlay
        ref={overlayRef}
        dimensions={dimensions}
        interactive={false}
        fadeDuration={200}
      />

      <PopupWindow
        ref={windowRef}
        name="pixi_connection_popup"
        fadeDuration={200}
        showButtons={false}
        showCloseButton={false}
        title="CONNECTION"
      >
        {popupText}
      </PopupWindow>
    </>
  );
};

export { CONNECTION_POPUP_TIMEOUTS };
export default ConnectionPopup;
